export function isRouteHandle(handle: unknown): handle is RouteHandle {
  return typeof handle === "object" && handle !== null && "title" in handle;
}

export interface RouteHandle {
  title: string;
}
